import React from "react"

export default ({ children }) => (
  <main id={`reach-skip-nav`} className={`docSearch-content`}>
    {children}
  </main>
)
